<template>
  <div>
    <v-row class="main_header py-4" >
      <v-col ref="colRef" class="pl-4 response-font text-start"  xs12 :cols="5" sm="7" md="7" style="color: #1B3A57;margin-top:10px">
            {{ headerTitle }}
              <div class="return-class">
                <router-link 
                  style="font-size: 14px; color: #0357D0;" 
                  :to="{ name: 'liquidationNew'}"
                  ><span v-if="action == 'create_lot' || action == 'file_upload'" v-on:click="handleCreateLotClick">Create Lot (Competitive Bidding)</span>
                  <span v-if="assignBuyer == true || action == 're_publish'" v-on:click="handleCreateLotClickPending">{{this.$store.state.navigate_tab.navigate_tab}}</span>
                  <span v-if="action == 'create_moq' || action == 'price_grid'" v-on:click="handleCreateLotMOQ">Create Lots (MOQ)</span>
                  <span v-if="action == 'edit_lot' || action == 'edit_moq' || action == 'edit_lot_moq'"  v-on:click="handleEditLot">Pending Publish (B2B)</span>
                  <span v-if="action == 'view_moq_items'"  v-on:click="handleEditLot">In Progress (B2B)</span>
                  <span v-if="action == 'vie_moq_PD'" v-on:click="handleCreateLotClickPending">Pending Decision</span>
                  <span v-if="action == 're_publish_payment'" v-on:click="handleNavigatePaymentTab">Pending Payment</span>
                </router-link> 
                <img
                  class="mt-3 image-align"
                    src="@/assets/images/icons/expand_more.svg"
                    width="7"
                    height="10"
                    v-if="createLotComtBidding == true || assignBuyer == true || action == 'create_moq' || action == 'price_grid' || action == 'edit_moq' || action == 'edit_lot_moq' || action == 'view_moq_items' || action == 're_publish_payment' || action == 'vie_moq_PD'"
                    /> 
                    <span v-if="action == 'price_grid'">
                    <router-link 
                          style="font-size: 14px; color: #0357D0;" 
                          :to="{ name: 'CreateLotsMOQ' }"                 
                          ><span v-if="action == 'price_grid'" @click="handleCreateLotMOQ2">Create Lot</span>
                        </router-link> 
                        <img
                        class="mt-3 image-align"
                        src="@/assets/images/icons/expand_more.svg"
                        width="7"
                        height="10"
                        v-if="action == 'price_grid'"
                        /> 
                        <span>Price Grid</span>
                    </span>
                    <span>
                    <span v-if="action == 'create_lot'">Create Lot</span>
                    <span v-if="action == 'edit_lot'"> Edit Lot {{ lotIdB2b }}</span>
                    <span v-if="action == 're_publish' || action == 're_publish_payment'"> Republish Lot {{ lotIdB2b }}</span>
                    <span v-if="action == 'file_upload'">Upload Lot File</span>
                    </span>
                    <span>
                    <span v-if="assignBuyer == true"> Assign Lot {{ lotIdB2b }} To A Buyer</span>
                    <span v-if="action == 'create_moq'">Create Lot</span>
                    <span v-if="action == 'edit_moq' || action == 'view_moq_items' || action == 'vie_moq_PD'"> Edit Lot {{lotIdB2b}} Inventory</span>
                    <span v-if="action == 'edit_lot_moq'"> Edit Lot {{lotIdB2b}} (Price Grid)</span>
                   </span>
              </div>
              <div class="d-flex ml-0" style="font-size: 14px" v-if="returnCondition == true">
                <router-link style="font-size: 14px; color: #0357D0;" :to="routerLink">
                  <span v-if="routerLinkText.toLowerCase() === 'back'">
                    <img class="mt-3 image-align" src="@/assets/images/icons/back-arrow.svg" width="25" height="20" />
                    <span style="font-size: 14px; color: #0357D0;">Back</span>
                  </span>
                  <span v-else>
                    {{ routerLinkText }}
                  </span>
                </router-link>
                <span v-if="routerLinkText && componentName" class="d-flex align-center">
                  <img class="my-1 image-align" src="@/assets/images/icons/expand_more.svg" width="7" height="10" />
                </span>
                <span >{{ componentName }}</span>
              </div>   
      </v-col>
      <v-col justify="center" xs=2 :cols="7" sm="5" md="5" class="d-flex flex-row-reverse align-self-center mt-2">
        <v-menu :close-on-content-click="false" :nudge-width="100" offset-y style="min-width: 150px; z-index: 999999;">
          <template #activator="{ props }">
            <span style="margin-right: 10px;" class="pull-right">
              <img align="center" src="@/assets/images/icons/profile_icon.png" height="24" width="24" v-bind="props"  />
            </span>
          </template>
          <v-list>
            <v-list-item style="background: #E1EEFA;">
              <v-list-item-content>
                <v-list-item-title
                  style="text-align:left;  font-size: 14px; font-weight:600; color: #1A1B35;">{{ organization_name }}</v-list-item-title>
                <v-list-item-subtitle style="text-align:left;color:#6E7089;">{{ this.user.email }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mb-0"></v-divider>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="pl-1"
                  style="text-align:left;  font-size: 14px; font-weight:600; color: #1A1B35;">
                  <a @click="openProfilePage" style="cursor: pointer;color:#00114B;"><v-icon style="color: #00114B;" class="pr-3">mdi-account-outline</v-icon>My Profile</a>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mb-0"></v-divider>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="pl-1"
                  style="text-align:left;  font-size: 14px; font-weight:600; color: #1A1B35;">
                  <a @click="openAlertPage" style="cursor: pointer;color:#00114B;"><v-icon style="color: #00114B;" class="pr-3">mdi-message-processing</v-icon>Support</a>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mb-0"></v-divider>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="pl-1" style="text-align:left;  font-size: 14px; font-weight:600; color: #1A1B35;" :disabled="logoutInProgress" v-if="!logoutInProgress">
                  <a @click="signOut" style="cursor: pointer;color:#D13F12;">
                    <v-icon style="color: #D13F12;" class="pr-3">mdi-logout-variant</v-icon>Logout
                  </a>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
        <span style="margin-right: 20px;" class="pull-right" v-if="user.roles.includes('warehouse_manager')">              
          <v-menu v-model="showNotifications" location="bottom" left>
          <template v-slot:activator="{ props }">
            <div class="notification_icon">
              <img align="center" src="@/assets/images/icons/bell_icons.png" height="24" width="24" @click="toggleNotifications" v-bind="props"/>
              <span v-if="notifications.length" class="notification-alerticon"></span>
            </div>
          </template>
          <v-list class="pb-0">
            <v-card class="mt-0 v-card-100">
              <b class="p-3">Notification</b> 
              <div class="notification-list">
                <div class="text-center pt-8" v-if="!notifications.length">There are no new notifications.</div>
                <v-list-item v-for="(notification,index) in notifications" :key="notification.id" class="py-0">
                  <v-list-item-title style="color: black;" :class="index != 0 ? 'top_border py-6' : 'py-6'">
                    <v-row class="pa-0 v-card-100">
                      <v-col cols="8" class="py-0">
                        <span>{{ notification.message.substring(0, 25) }}...</span>
                      </v-col>
                      <v-col cols="4" class="py-0">
                        <span>{{ notification.time }}</span> 
                        <span><v-icon color="error" style="font-size:10px" class="ml-3"> mdi-circle</v-icon></span>
                      </v-col>
                    </v-row>
                  </v-list-item-title>             
                </v-list-item>
              </div>
              <a @click="openNotificationPage" class="view-all-style">View All</a>
            </v-card>
          </v-list>
        </v-menu>
      </span>       
        <span class="pull-right" style="width: 123px; margin-right: 15px; margin-top: 7px;">
          <div class="profile_details">
            <v-tooltip location="bottom">
              <template v-slot:activator="{ props }">
                <div v-bind="props">
                  <span v-if="user.first_name.length <= 12" class="user-name">
                    {{ user.first_name }}
                  </span>
                  <span v-else class="user-name">
                    {{ user.first_name.substring(0, 12) }}...
                  </span>
                </div>
              </template>
              <span>
                {{ user.first_name }}
              </span>
            </v-tooltip>
            <v-tooltip location="bottom">
              <template v-slot:activator="{ props }">
                <div v-bind="props">
                  <span v-if="user.roles[0].length <= 15" class="user-role">
                    {{ user.roles[0] }}
                  </span>
                  <span v-else class="user-role">
                    {{ user.roles[0].substring(0, 15) }}...
                  </span>
                </div>
              </template>
              <span>
                {{ user.roles[0] }}
              </span>
            </v-tooltip>
          </div>
        </span>
        
        <div class="pull-right" style="margin-right: 20px; width: 280px;">
          <v-menu
            class="rpa_css"
            v-model="menu"
            close-on-content-click="false"
            max-width="190"
            max-height="240"
            offset-y
          >
            <template class="rpa_css"  v-slot:activator="{ props }">
              <v-autocomplete
                v-model="current_warehouse"
                :items="filteredMenuItems"
                item-title="code"
                item-value="id"
                multiple
                variant="outlined"
                dense
                  :label="menu_items[0] ? (menu_items[0].code.length > 15 ? menu_items[0].code.slice(0, 15) + '...' : menu_items[0].code) : 'Select'"
                v-bind="props"
                :item-props="getItemProps"
                style="height: 40px!important;"
                class="rpa_css text-left"
                :menu="false"
                hide-details
              >
                <template #selection="{ item, index }">
                  <span class="mt-4">
                    <span v-if="index < 1">
                      {{ truncateText(item.title) }}<span v-if="index < current_warehouse.length - 1">, </span>
                    </span>
                    <span v-if="index === 1">... ({{ current_warehouse.length }})</span>
                  </span>
                </template>
                <template v-slot:append-item>
                  <v-card-actions style="position: sticky; bottom: -10px; background: white;">
                    <v-spacer></v-spacer>
                    <v-btn class="text-none" color="primary" variant="flat" :disabled="!current_warehouse.length" @click="changeWarehouse">Ok</v-btn>
                  </v-card-actions>

                </template>
              </v-autocomplete>
            </template>
          </v-menu>
        </div>
      </v-col>
    </v-row>
    <hr class="mb-0 mt-3">
  </div>
</template>
<style >
.client-name {
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  color: #4f4f4f;
}

.v-application a {
  color: #333333;
  font-weight: bold;
  font-size: 12px;
}
.v-application .pl-4 {
    padding-left: 23px!important;
}
.v-menu__content {
    background-color: #ffffff;
    top: 55px !important;
}
.user-name {
  font-size: 16px;
  line-height: 19.36px;
  text-align: right;
  font-weight: 400;
  color: #2D2D2D;
  position: relative;
  display: flex;
  justify-content: flex-end;
}
.user-role {
  font-size: 12px;
  line-height: 14.52px;
  text-align: right;
  color: #9C9C9C;
  font-weight: 700;
  display: flex;
  position: relative;
  justify-content: flex-end;
}
.fixed-button-container {
  position: sticky;
  bottom: 0;
  background-color: white;
  padding-top: 10px;
  padding-bottom: 10px;
  z-index: 1;
}
.rpa_css{
    --v-input-control-height: 38px !important;
    --v-input-padding-top: 0px !important;
    border-color: black;
    color: black;
}
.notification-list {
  min-height: 100px;
  min-width: 400px;
  max-height: 200px; /* Restrict height */
  overflow-y: auto;  /* Enable scrolling */
}
.top_border{
  border-top: 1px solid grey;
}
.view-all-style{
 cursor: pointer;
    color: #1976d2 !important;
    position: relative;
    left: 80%;
    font-size: 16px !important;
    text-decoration: underline !important;
}
</style>

<script>
import { defineComponent } from 'vue'; 

export default defineComponent({
  // props: ["headerTitle","createLotComtBidding","lotIdB2b","assignBuyer","action", "returnCondition", "salesReturnCondition"],

  props: {
    headerTitle: {
      type: String,
      required: true,
    },
    createLotComtBidding: {
    },
    lotIdB2b: {
    },
    assignBuyer: {
    },
    action: {
    },
    salesReturnCondition: {
    },
    subLotQuantity:{

    },
    subLotsPossible:{},
    
    routerLink: {
      type: Object,
      default: () => ({ name: '' }),
    },
    routerLinkText: {
      type: String,
      default: '',
    },
    returnCondition: {
      type: Boolean,
      default: true,
    },
    showImage: {
      type: Boolean,
      default: true,
    },
    componentName: {
      type: String,
      default: '',
    },
  },
  computed: {
    showImageArrow() {
      return this.routerLinkText && this.componentName;
    },
  },
  data() {
    return {
      files: [],
      user:"",
      attachmentLabel: "Attachment Documents",
      menu_items: [],
      current_warehouse: null,
      number:0,
      logoutInProgress: false,
      possible_of_sublot:'',
      subLotsQuantity:'',
      organization_name:'',
      menu: false,
      showNotifications: false,
      selectedItems: [],
      notifications: [],
      showNotifications: false,    
    };
  },
  created() {
    this.user = this.$store.state.currentUser;
    this.organization_name = this.$store.state.organization_name
    this.menu_items = this.$store.state.currentUser.available_distribution_centers
    this.current_warehouse = [...this.$store.state.current_warehouse]    
    this.selectedItems = [...this.current_warehouse];
    this.possible_of_sublot = this.$store.state.subLotsPossible
    this.subLotsQuantity = this.$store.state.subLotQuantity
    if (this.menu_items.length === 1) {
      const singleItem = this.menu_items[0].id;
      this.current_warehouse = this.menu_items;
      this.selectedItems = [singleItem];
      this.$store.commit('setCurrentWarehouse', { distribution_id: [singleItem] });
    }
    if(this.user.roles.includes('warehouse_manager'))
      this.fetchNotifications()
  },
  mounted() {
    this.adjustFontSize();
    window.addEventListener('resize', this.adjustFontSize);
  },
  destroyed() {
    window.removeEventListener('resize', this.adjustFontSize);
  },
  components: {
    },
    computed: {
    isSidebarExpanded() {
      return this.$store.state.isSidebarExpanded;
    },
    filteredMenuItems() {
      const isAllRPASelected = this.current_warehouse.includes(0);
      if (isAllRPASelected) {
        return this.menu_items.map(item => ({
          ...item,
          code : `${item.code} (${item.name})`,
          disabled: item.id !== 0
        }));
      }
      return this.menu_items.map(item => ({
        ...item,
         code : `${item.code} (${item.name})`,
        disabled: false
      }));
    },
    menuStyle() {
      // Default values for demonstration (adjust these as per your actual needs)
      const expandedLeft = 1800; // For expanded state
      const collapsedLeft = 1630; // For collapsed state

      // Determine the left value based on the sidebar state and subtract 200px
      const leftValue = this.isSidebarExpanded
        ? `${expandedLeft - 200}px`
        : `${collapsedLeft - 200}px`;

      return {
        left: leftValue,
        position: 'absolute', // Ensure the position is absolute
        transition: 'left 0.3s ease', // Add a transition for smooth effect
      };
    },
  },
   watch: {
    current_warehouse(newVal) {
      const allRPASelected = newVal.includes(0);
      if (allRPASelected && newVal.length > 1) {
        this.$nextTick(() => {
          this.current_warehouse = [0];
        });
      }
    }
  },
  methods: {
    truncateText(text) {
    if (!text) return '';
    return text.length > 6 ? text.slice(0, 8) + '...' : text;
  },
    getItemProps(item) {
        return { disabled: item.disabled };
    },
    adjustFontSize() {
      const col = this.$refs.colRef;
      const maxWidth = col.offsetWidth;
      const text = col.innerText;
      const span = document.createElement('span');
      span.style.fontSize = '32px'; // Initial font size
      span.innerText = text;
      document.body.appendChild(span);
      const screenWidth = window.innerWidth;
      if (screenWidth < 600) {
        span.style.fontSize = '20px';
      } else if (screenWidth < 1025) {
        span.style.fontSize = '24px';
      } else {
        span.style.fontSize = '28px';
      }

      col.style.fontSize = span.style.fontSize;
      document.body.removeChild(span);
    },
    fileAttachment(event) {
      let attachmentObj = {
        attachedfFiles: this.files,
      };
      this.$emit("clicked", attachmentObj);
    },
    async signOut() {
      if (this.logoutInProgress) {
        return;
      }
      this.logoutInProgress = true;
      try {
        await this.$httpSecured.delete("/api/v1/logout");
        this.$router.replace("/");
        this.$store.commit("unsetCurrentUser");
        this.$store.commit("unsetSelectedLot");
        this.$store.commit("setCurrentWarehouse", { distribution_id: "" });
        this.$toast.success("Logout successful");
        this.$store.commit("setFTALogistics", { fta_logistics: null });
      } catch (error) {
        this.$toast.error("Error in logging out");
      } finally {
        this.logoutInProgress = false;
      }
    },

    changeWarehouse(){
      // this.current_warehouse = [...this.selectedItems]
      this.menu = false;
      if (this.current_warehouse == 0){
        this.$store.commit("setCurrentWarehouse", {distribution_id: ''})
        this.current_warehouse = null
      }else{
        this.$store.commit("setCurrentWarehouse", {distribution_id: this.current_warehouse})
      }
      this.$router.go()
    },
    handleCreateLotClick(){
      this.$store.commit("setMessage", { 
        action:'create_lot'
      });      
    },
    handleCreateLotClickPending(){
       if(this.$store.state.navigate_tab.navigate_tab === 'Pending Decision'){
       this.$store.commit("setMessage", { 
        action:'re_publish_return'
      }); 
      }else if(this.$store.state.navigate_tab.navigate_tab === 'Pending Payment'){
        this.$store.commit("setMessage", { 
        action:'re_publish_return_payment'
      }); 
      }
    },
    handleCreateLotMOQ(){
      this.$store.commit("setMessage", { 
        action:'create_moq'
      }); 
    },
    handleCreateLotMOQ2(){
      this.$store.commit("setSubLotQuantity", {
            action:'create_moq_return',
            subLotQuantity: this.subLotsQuantity,
            subLotsPossible: this.possible_of_sublot
          }) 
    },
    handleEditLot(){
      if(this.action == 'view_moq_items'){
        this.$store.commit("setMessage", { 
        action:'edit_lot_view'
      });  
      }else{

        this.$store.commit("setMessage", { 
          action:'edit_lot'
        });  
      }
    },
    handleNavigatePaymentTab(){
      this.$store.commit("setMessage", { 
        action:'re_publish_return_payment'
      }); 
    },
    openProfilePage(){
      this.$router.push({ name : 'ProfilePage'});
    },
    openAlertPage() {
      this.$router.push({ name: 'AlertComponent', query: { support: 'support', key: Date.now() } });
    },
    openNotificationPage(){
      this.$router.push({ name: 'notification'})
    },
    toggleNotifications(){  
      this.showNotifications = !this.showNotifications;
    },
    fetchNotifications() {
      this.$httpSecured
      .get("/api/v2/item_notifications/get_item_notifications?is_read=false")
      .then(response => {
        this.notifications = response.data.data
        setTimeout(() => {
            this.fetchNotifications();
        }, 600000);
      })
      .catch(error => {
        this.$toast.error(error.response.data.error)
      });
    },
  },
});
</script>
<style>
.return-class {
  font-size: 14px !important;
  position: absolute !important;
  /* bottom: 24px !important; */
  left: 16px !important; 
}
.image-align{
    margin-bottom: 15px;
    margin-left: 6px;
    margin-right: 6px;
}
.notification_icon {
  position: relative;
  display: inline-block;
}

.notification-alerticon {
  position: absolute;
  top: 11px;
  right: 2px;
  width: 9px;
  height: 9px;
  background-color: red;
  border-radius: 50%;
  border: 1px solid white;
}
 </style>
